import { Dimmer, Loader, Segment } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';
import { MODES_REGLEMENTS } from '@/constants';
import { LoadingContext, ModeReglementContext } from '@/contexts';
import GestionPrelevements from './GestionPrelevements';
import PrelevementDesactiveMessage from './PrelevementDesactiveMessage';

const PrelevementRouter = () => {
  const { modesReglementsLoadings } = React.useContext(LoadingContext);
  const { regieModesReglement: modesReglementsLoading } = modesReglementsLoadings || {};

  const { regieModesReglement } = React.useContext(ModeReglementContext);

  const hasPrelevement = React.useMemo(
    () =>
      _.size(regieModesReglement) > 0 &&
      _.some(regieModesReglement, ({ code }) => code === MODES_REGLEMENTS.PRELEVEMENT),
    [regieModesReglement],
  );

  if (_.isNil(regieModesReglement) || modesReglementsLoading) {
    return (
      <Dimmer active inverted>
        <Loader inverted>Chargement des modes de règlement de la régie</Loader>
      </Dimmer>
    );
  }

  return hasPrelevement ? (
    <Segment inverted secondary style={{ flex: 1, background: 'transparent' }}>
      <Segment
        style={{
          paddingBottom: 0,
          paddingRight: 0,
          paddingLeft: 0,
          borderRadius: 14,
        }}
      >
        <GestionPrelevements />
      </Segment>
    </Segment>
  ) : (
    <PrelevementDesactiveMessage />
  );
};

export default PrelevementRouter;
